import { ApiClient } from '@/common/api/ApiClient';
import {
  buildMockTelemetryFields,
  buildMockTelemetryResponse,
} from '@/features/telemetry/services/telemetryMockData';
import {
  telemetryFieldListSchema,
  telemetryResponseSchema,
  type TelemetryField,
  type TelemetryResolution,
  type TelemetryResponse,
} from '@/features/telemetry/services/schemas';

export interface TelemetryQueryParams {
  from: Date;
  /** Exclusive — see the API doc on the `to` query param. */
  to: Date;
  resolution: TelemetryResolution;
  /** Base variable names (no `_avg`/`_last` suffix). Omit for every field. */
  fields?: string[];
}

export const TelemetryService = {
  getFields: (systemId: number): Promise<TelemetryField[]> => {
    return ApiClient.get(
      `/timeseries/system/${systemId}/telemetry/fields`,
      telemetryFieldListSchema,
      undefined,
      { mock: () => buildMockTelemetryFields() as TelemetryField[] }
    );
  },

  getTelemetry: (systemId: number, params: TelemetryQueryParams): Promise<TelemetryResponse> => {
    return ApiClient.get(
      `/timeseries/system/${systemId}/telemetry`,
      telemetryResponseSchema,
      {
        from: params.from.toISOString(),
        to: params.to.toISOString(),
        resolution: params.resolution,
        ...(params.fields?.length ? { fields: params.fields.join(',') } : {}),
      },
      { mock: () => buildMockTelemetryResponse(params) as TelemetryResponse }
    );
  },
};
